<template>
	<div class="tutorService">
		<div class="parkService__title">
			<p>导师服务</p>
			<div class="parkService__border"></div>
		</div>
		<div class="parkService__service">
			<div class="parkService__content tutorService__mrg">
				<p>
					为了更好地提升孵化服务质量，协助园区科技企业解决经营痛点或技术难点，提高企业竞争力，{{
						companyAlias
					}}孵化器聘请了刘桂雄、蔡念等20位创业导师，为企业提供创业辅导服务。辅导形式有“创业门诊”、
					“一对一”帮扶企业、创业沙龙、创业培训等,
					为科技创新企业提供专业孵化、创业辅导、科技咨询、创业培训、法律支持、技术支撑、知识产权等全方位的服务。
				</p>
				<br />
				<p>
					{{
						companyAlias
					}}孵化器为园区企业免费提供创业导师服务园区科技企业有创业辅导需求的，可根据创业导师团20位导师擅长领域，填写《创业导师需求表》交中国科协广州科技园项目拓展部。辅导费用全免，服务团队将安排落实导师辅导时间，原则性每家科技企业每次可选一位导师，一年不超过6次。
				</p>
			</div>
			<p class="parkService__font" style="text-align: left">
				创业导师服务只面对园区企业免费提供，请园区有需要的企业填好《创业导师需求表》发送至280915805@qq.com。
			</p>
			<div class="parkService__btn" @click="handleClickDownload">
				下载创业导师需求表
				<i class="el-icon-download"></i>
			</div>
			<div class="tutorService__teather">
				<div class="tutorService__line"></div>
				<div class="tutorService__title">专业创业导师团</div>
				<div class="tutorService__line"></div>
			</div>
			<div class="tutorService__person">
				<div
					class="tutorService__box"
					v-for="tutor in tutorList.list"
					:key="tutor.id"
					@click="handleDialogVisible(tutor.id)"
				>
					<div class="tutorService__card">
						<img :src="tutor.head" alt />
						<h2>{{ tutor.name }}</h2>
						<p style="color: #000000">{{ tutor.honour }}</p>
						<p>{{ tutor.position }}</p>
						<p>{{ tutor.workExperience }}</p>
					</div>
				</div>
				<div></div>
			</div>
			<div class="list-page__footer">
				<el-pagination
					@current-change="handleCurrentChange"
					:current-page.sync="tutorList.pageNumber"
					:page-size="tutorList.pageSize"
					layout="prev, pager, next, jumper"
					:total="tutorList.totalRow"
				/>
			</div>
		</div>
		<el-dialog
			:visible.sync="dialogVisible"
			width="50%"
			:before-close="handleClose"
		>
			<div class="tutorService__dialog">
				<div
					class="tutorService__box tutorService__mr"
					@click="dialogVisible = true"
				>
					<img :src="tutorDetail.head" alt />
					<h2>{{ tutorDetail.name }}</h2>
					<p style="color: #000000">{{ tutorDetail.honour }}</p>
					<p>{{ tutorDetail.position }}</p>
					<p>{{ tutorDetail.workExperience }}</p>
				</div>
				<div
					class="parkService__content"
					v-html="tutorDetail.successProject"
				>
					<!-- <p>
						重庆大学仪器科学与技术专业工学博士，从事现代传感与智慧物联、精密检测与仪器仪表、光机电一体信息集成与装备等方面教学科研工作。广东省“千百十”省级带头人、教育部新世纪优秀人才计划和广东省高等学校高层次人才项目获得者。兼任广州市科协常委、中国仪器仪表学会常务理事、政协第十三届广州市委员会委员、省测量控制技术与装备应用促进会理事长、广州市仪器仪表学会执行理事长、省无损检测学会理事长、省仪器仪表学会副理事长、省计量测试学会副理事长、省LED标准联盟专家组副组长、全国误差及不确定度研究会副理事长、中国仪器仪表学会精密机械分会副理事长、广州市仪器仪表与智能测控技术创新联盟理事长、广东省智能仪器仪表与测控技术产业创新联盟理事长，全国体系结构、通信和集成框架标委会委员。
					</p>
					<br />
					<p>
						担任《仪器仪表学报》、《光学精密工程》等杂志编委。近年主持包括国家重大科学仪器开发专项、国家自然科学基金、粤港澳重点招标项目等在内的科研项目50余项，取得国家发明专利授权38项，出版专著2部，主编地方技术标准2部。2016年任广东省计量质量标准化专业教授级高工评审委员会专业组组长。
						“一对一”帮扶企业、创业沙龙、创业培训等,
						为科技创新企业提供专业孵化、创业辅导、科技咨询、创业培训、法律支持、技术支撑、知识产权等全方位的服务。
					</p> -->
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
	props: {},
	data() {
		return {
			dialogVisible: false,
			page: 1,
		}
	},
	computed: {
		...mapState(['companyAlias']),
		...mapState('FHFW', ['tutorList', 'tutorDetail', 'total', 'limit']),
	},
	created() {
		this.fetchTutorList({ page: this.page })
	},
	mounted() {},
	watch: {},
	methods: {
		...mapActions('FHFW', ['fetchTutorList', 'fetchTutorDetail']),
		...mapMutations('FHFW', ['tutorDetailClear']),
		handleClose(done) {
			this.tutorDetailClear()
			done()
		},
		async handleDialogVisible(id) {
			await this.fetchTutorDetail({ id })
			this.dialogVisible = true
		},
		handleCurrentChange(page) {
			this.fetchTutorList({ page })
		},
		handleClickDownload() {
			try {
				window.location.href = mentorNeedsUrl || ''
			} catch (e) {
				console.log(e)
			}
		},
	},
	components: {},
}
</script>

<style lang="scss">
.tutorService {
	text-align: center;
	&__mrg {
		margin: 30px auto;
	}
	&__teather {
		display: flex;
		justify-content: space-around;
		line-height: 40px;
		margin-bottom: 30px;
	}
	&__line {
		width: 200px;
		height: 1px;
		background: #00a1e0;
		margin: auto;
	}
	&__title {
		font-size: 28px;
		font-weight: 600;
		color: #00a1e0;
		letter-spacing: 2px;
	}
	&__person {
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;
	}
	&__card {
		width: 180px;
		margin: 0 auto;
	}
	&__box {
		margin-bottom: 40px;
		text-align: left;
		width: 33.3333333%;
		img {
			object-fit: cover;
			width: 180px;
			height: 252px;
		}
		h2 {
			font-size: 21px;
			color: #000000;
			line-height: 29px;
			text-align: center;
			margin: 10px auto;
		}
		p {
			font-size: 14px;
			line-height: 20px;
			text-align: center;
			color: rgba(0, 0, 0, 0.45);
		}
	}
	&__dialog {
		display: flex;
		justify-content: space-around;
	}
	&__mr {
		margin-right: 30px;
	}
}
</style>
